import React from "react";
import { TrendingDown } from "lucide-react";

// "Save X% at 3 / 5 vials" nudges — one tappable row per upcoming tier.
export default function NextTierCallout({ tiers, qty, listUnit, onPick }) {
  if (!listUnit) return null;
  const rows = tiers
    .filter((t) => (t.min_qty === 3 || t.min_qty === 5) && t.min_qty > qty)
    .map((t) => ({ ...t, pct: Math.round((1 - t.unit_price / listUnit) * 100) }))
    .filter((t) => t.pct > 0);
  if (!rows.length) return null;

  return (
    <div data-testid="next-tier-callout" className="mt-4 space-y-2">
      {rows.map((t) => (
        <button
          key={t.min_qty}
          type="button"
          data-testid={`next-tier-callout-${t.min_qty}`}
          onClick={() => onPick(t.min_qty)}
          className="w-full text-left border border-[#00C3FF]/40 bg-[#00C3FF]/5 hover:bg-[#00C3FF]/10 transition-colors p-4 flex items-start gap-3"
        >
          <TrendingDown size={16} className="text-[#00C3FF] mt-0.5 shrink-0" />
          <div>
            <div className="font-mono-tech text-[11px] uppercase tracking-[0.2em] text-[#00C3FF]">
              Save {t.pct}% at {t.min_qty} vials
            </div>
            <div className="text-xs text-[#8A94A6] mt-1 leading-relaxed">
              ${t.unit_price.toFixed(2)}/vial vs ${listUnit.toFixed(2)}.
              {t.min_qty >= 5
                ? `${t.pct > 10 ? " A bigger saving than a 10% promo code." : ""} Promo codes apply to 1–4 vials only.`
                : " Promo codes still apply at 3 vials."}
              <span className="text-white"> Tap to switch to {t.min_qty}.</span>
            </div>
          </div>
        </button>
      ))}
    </div>
  );
}
